

// export const Api = "http://localhost/infronex";

// // export const Api = "https://infronex.com";


const isProduction = process.env.NODE_ENV === "production";

export const Api = isProduction
  ? "https://infronex.com"
  : "http://localhost/infronex";
